<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols='12'>

<!-- table displaying totals  -->
          <v-data-table
            :loading='isLoading'
            dense
            :headers='totalHeaders'
            :items='totals'
            class='grey lighten-3'
            hide-default-footer
            disable-pagination
            disable-sort
          >
            <!-- <template v-slot:item.text v-if='budget'>
              <span class='caption mr-2'>{{ budget + ' Budgeted hours. ' + (budget - totals[0].total_hours) + ' remaining'}}</span>
              <v-progress-circular :value='budgetUsed' color='green' size='24' rotate='270' width='6'></v-progress-circular>
              <span class='caption ml-2'>{{ budgetUsed + '% Used' }}</span>
            </template> -->

            <template v-slot:item.total_hours='{ item }'>
              <span class='font-weight-bold'> {{ item.total_hours.toFixed(2) }}</span>
            </template>
          </v-data-table>

<!-- main table showing all categories -->
          <v-data-table
            dense
            :headers='headers'
            :items='categories'
            :expanded.sync='expanded'
            item-key='index'
            :no-data-text='project.detail_required ? "No Timesheets Entries for this Project found" : "Timesheet details are set to NOT Required"'
            hide-default-footer
            disable-pagination
          >
          <!-- possible expansion panels might be needed later? -->
          <!-- though - if we want employee data, we need to think how to get/display that as workedOns have no knowledge of the profile assignee -->
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import _ from 'lodash'
// import moment from 'moment'
import timesheetsAPI from '@/modules/timesheets/api/timesheets'
import staffingAPI from '@/modules/staffing/api/staffing'
// import ConstructionEntryTable from './ConstructionEntryTable'

export default {
  name: 'construction-reports',
  props: {
    project: {
      required: true
    }
  },
  data: () => ({
    isLoading: true,
    showDialog: false,
    categories: [],
    expanded: [],
    profiles: [],
    workedOns: [],
    headers: [
      { text: 'Assigned Detail Description', value: 'text', class:'overline', align: 'start', width: '350' },
      { text: '', value: 'alerts', class:'overline', align: 'end', sortable: false },
      { text: 'Hours', value: 'hours', class:'overline', align: 'end', width: '100' },
      // { text:'', value: 'data-table-expand' }
    ],
    totalHeaders: [
      { text: '', value: 'text', class:'overline white', align: 'start' },
      { text: '', value: 'alerts', class:'overline white', align: 'end', width: '300'},
      { text: '', value: 'total_hours', class:'overline white', align: 'end', width: '100' },
      // { text:'', value: 'blank_space', class: 'white', width: '56' }
    ]
  }),
  mounted () {
    this.getData()
  },
  computed: {
    totals () {
      return [{
        alerts: 'Total assigned to this Project:',
        total_hours: this.getTotalReportHours()
      }]
    },
    budget () {
      // you may want to add the default labour price used for the invoice here?
      return this.project.project_detail.po_total / 100   // 100 acting as an assumed labour price
    },
    budgetUsed () {
      if (this.categories.length && this.budget ) {
        let num = this.totals[0].total_hours / this.budget * 100
        return num.toFixed(0)
      }
      return 0
    },
  },
  methods: {
    async getData() {
      this.isLoading = true
      this.profiles = await staffingAPI.getProfiles()
      this.workedOns = await timesheetsAPI.getProjectWorkedOns(this.$route.params.id)
      await this.runCalcs()
      this.isLoading = false
    },
    runCalcs () {
      let assignedDetails = []
      this.workedOns.forEach( (w,i) => { if (w.detail) { assignedDetails.push({
        text: w.detail_obj.description, index:i, hours: this.getHours(w.detail_obj.description) 
      }) } })
      this.categories = _.uniq(assignedDetails)
    },
    getTotalReportHours () {
      return _.sumBy(this.workedOns, 'num_hours')
    },
    getHours(category) {
      let tmp = _.filter(this.workedOns, w => w.detail_obj.description == category)
      return _.sumBy(tmp, 'num_hours')
    }
  },
  components: {
    // 'entry-table': ConstructionEntryTable
  }
}
</script>